<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="internal-information-wrapper">
        <div class="internal-information container col-lg-10 col-sm-12">
          <InternalInformationSection
            :key="editKey"
            :initial-values="internalInformation"
            @change="handleChange"
            :bookingId="currentBookingId"
            ref="internalInformationForm"
          />
        </div>
      </div>
    </template>
    <template v-slot:dialog.action>
      <v-spacer />
      <PrimaryButton @click.native="save" :loading="isLoading">
        Save
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import InternalInformationSection from "@/views/bookings/NewBooking/steps/components/InternalInformationSection";
import { EDIT_BOOKING_WITH_MESSAGE } from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { pick } from "lodash";
import generateId from "uuid/v4";

const { mapActions } = createNamespacedHelpers("bookings");

export default {
  name: "EditInternalInfo",
  components: {
    PrimaryButton,
    InternalInformationSection,
    DialogFull
  },
  computed: {
    dialogSettings() {
      return {
        title: "Edit Internal Information",
        dialog: this.isOpen
      };
    },
    initialData() {
      return pick(this.internalInfo, [
        "postNumber",
        "poNumber",
        "manager",
        "hireReason",
        "vacancies",
        "client",
        "internalOnly",
        "applyLinkOverride",
        "anonymiseApplications",
        "maximumApplications"
      ]);
    },
    initialDataWithReason() {
      return {
        ...this.initialData,
        reason: this.initialData && this.initialData.hireReason
      };
    }
  },
  mounted() {
    this.internalInformation = this.initialDataWithReason;
  },
  data() {
    return {
      isLoading: false,
      internalInformation: this.initialDataWithReason,
      editKey: generateId()
    };
  },
  props: {
    isOpen: Boolean,
    internalInfo: Object
  },
  inject: ["currentBookingId"],
  methods: {
    ...mapActions({
      editBooking: EDIT_BOOKING_WITH_MESSAGE
    }),
    handleChange(editedInformation) {
      this.internalInformation = editedInformation;
    },
    close() {
      this.$emit("close");
    },
    save() {
      const isFormValid = this.$refs.internalInformationForm.isValid();
      if (isFormValid) {
        this.saveBookingDetails();
      }
    },
    async saveBookingDetails() {
      this.isLoading = true;
      await this.editBooking({
        bookingId: this.currentBookingId,
        editedBooking: {
          ...this.internalInformation,
          assessmentsAllowed: !!this.internalInformation.assessmentsAllowed,
          hireReason: this.internalInformation.reason,
          poNumber: this.internalInformation.poNumber || "",
          internalOnly: Boolean(this.internalInformation.internalOnly),
          costCode: this.internalInformation.client.costCode,
          client: this.internalInformation.client,
          vacancies: this.internalInformation.vacancies,
          applyLinkOverride: this.internalInformation.applyLinkOverride,
          anonymiseApplications: Boolean(
            this.internalInformation.anonymiseApplications
          )
        }
      });
      this.close();
      this.isLoading = false;
    }
  },
  watch: {
    isOpen() {
      this.editKey = generateId();
    }
  }
};
</script>

<style lang="scss">
.edit-internal-information-content {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
</style>
